// Die Ansatzliste eines Aufmassblatts (GB-20).
//
// Nach dem Speichern rendert der Server die ganze Liste neu (die Summen und der
// Fortschritt je Position haengen an jedem Ansatz). Dieser Controller oeffnet danach
// dieselbe Schnellerfassungszeile wieder, die gerade abgeschickt wurde — mit
// vorbelegter Position und Fokus im Bezeichnungsfeld. Damit laesst sich ein
// Fassadenumgang Zeile fuer Zeile abschreiben, ohne die Maus anzufassen; genau das
// meint "Zeile anhaengen" auf einem Aufmassblatt nach REB 23.003.
//
// Gleiche Mechanik wie im Positionsbaum des Angebots, aber mit eigenem Fenster-Schluessel:
// beide koennen nicht gleichzeitig auf einer Seite stehen, ein geteilter Schluessel waere
// trotzdem eine unnoetige Kopplung.
import { Controller } from "@hotwired/stimulus"

const REOPEN_WINDOW_MS = 5000

export default class extends Controller {
  connect() {
    this.reopenQuickAdd()
  }

  reopenQuickAdd() {
    const reopen = window.__measurementEntryReopen
    window.__measurementEntryReopen = null
    if (!reopen || Date.now() - reopen.at > REOPEN_WINDOW_MS) return

    // Erst im naechsten Frame klicken: connect() laeuft, bevor die inneren Controller
    // (inline-add-form) verbunden sind. Ein sofortiger Klick erreicht deren Aktion nicht,
    // Turbo folgt dem Link dann im umgebenden Frame der Liste — "Content missing".
    requestAnimationFrame(() => {
      const link = this.element.querySelector(`a[href="${reopen.href}"]`)
      if (link) link.click()
    })
  }
}
